import { React, useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import urls, { getCsrfToken } from '../com.zedock.common.script/urls.js';
import { clicks } from '../com.zedock.common.script/common.js';
import { updateCartCount } from '../com.zedock.common.script/Header.js';

import '../com.zedock.common.style/cart.css';
import '../com.zedock.common.style/common.css';

function currency(n) {
  return `₹${n.toLocaleString("en-IN")}`;
}

function Cart() {
  const navigate = useNavigate();
  const location = useLocation();
  const T = {
    ink: "#0F2620",
    teal: "#0F3D36",
    paper: "#FFFFFF",
    fog: "#F4F7F5",
    limeDeep: "#9CBA1F",
    coral: "#FF6B4A",
    muted: "#6B7770",
    line: "#E4E9E6",
  };
  const [loading, setLoading] = useState(false);
  const [cart, setCart] = useState([]);
  const [count, setCount] = useState(1);
  const total = cart.reduce((acc, item) => acc + item.price * item.quantity, 0);

  useEffect(() => {
    clicks(location.pathname);
    const qw = document.cookie.match(new RegExp('(^| )' + 'products' + '=([^;]+)'));

    if (qw != null) {
      getCartFromCookies(setCart, navigate, location);
    }
    else {
      getCart(setCart, navigate, location);
    }
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    document.cookie = 'cartCount=' + cart.length
    updateCartCount(cart.length);
  }, [cart]);

  async function getCartFromCookies(setCart, navigate, location) {
    const expressionProduct = document.cookie.match(new RegExp('(^| )' + 'products' + '=([^;]+)'));
    try {
      setLoading(true);
      const cookiesCart = expressionProduct[0].split('products=')[1]
      const response = await
        fetch(`${urls.BASE_URL}` + "/zedock-web/cart/cookiesCart?cookies=" + cookiesCart, {
          headers: {
            "X-XSRF-TOKEN": getCsrfToken()
          },
          method: "GET",
          credentials: "include"
        })
      if (response.status === 401) {
        localStorage.clear();
        return null;
      }
      const data = await response.json();
      setCart(data);
    } catch (error) {
      document.cookie = "products=; path=/; max-age=0";
      setCart([]);

      console.error("Error:", error);
    } finally {
      setLoading(false);
    }

  };

  async function getCart(setCart, navigate, location) {
    try {
      setLoading(true);

      const response = await
        fetch(`${urls.BASE_URL}` + "/zedock-web/cart", {
          headers: {
            "X-XSRF-TOKEN": getCsrfToken()
          },
          method: "GET",
          credentials: "include"
        })
      if (response.status === 401) {
        localStorage.clear();
        return null;
      }

      const data = await response.json();
      setCart(data);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }

  };
  const handlePutToCart = async (e) => {
    try {
      setLoading(true);

      const response = await
        fetch(`${urls.BASE_URL}` + "/zedock-web/cart", {
          method: "PUT",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "X-XSRF-TOKEN": getCsrfToken()
          },
          body: JSON.stringify(e)
        });
      if (response.status === 401) {
        return null;
      }
      navigate("/Cart")
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };


  const removeFromCart = async (id) => {

    const expressionProduct = document.cookie.match(new RegExp('(^| )' + 'products' + '=([^;]+)'));
    try {
      setLoading(true);
      const response = await fetch(`${urls.BASE_URL}/zedock-web/cart/${id}`, {
        method: "DELETE",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "X-XSRF-TOKEN": getCsrfToken()
        }
      });
      if (response.status === 401) {
        if (expressionProduct[0].split('products=')[1].split(',').length > 1) {
          const regex = new RegExp(id + "-\\d+,");
          document.cookie = "products=" + expressionProduct[0].split('products=')[1].replace(regex, '');
        }
        getCartFromCookies(setCart, navigate, location);
        return null;
      }
      setCart(cart.filter(item => item.id !== id));
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };




  const increaseQuantity = (id) => {
    const expressionProduct = document.cookie.match(new RegExp('(^| )' + 'products' + '=([^;]+)'));

    const updatedCart = cart.map(item => {
      if (item.id === id) {
        const list = expressionProduct?.[0]?.split('products=')[1]?.split(',') ?? [];
        if (list.length > 1) {
          const regex = new RegExp(item.id + "-\\d+");
          document.cookie = "products=" + expressionProduct[0].split('products=')[1].replace(regex, (item.id + '-' + (item.quantity + 1)));
        }
        return { ...item, quantity: item.quantity + 1 }
      }
      else
        return item
    });

    setCart(updatedCart);
    handlePutToCart(updatedCart);

  };

  const decreaseQuantity = (id) => {
    const expressionProduct = document.cookie.match(new RegExp('(^| )' + 'products' + '=([^;]+)'));

    const updatedCart = cart.map(item => {
      if (item.id === id) {
        const list = expressionProduct?.[0]?.split('products=')[1]?.split(',') ?? [];
        if (list.length > 1 && item.quantity > 1) {
          const regex = new RegExp(item.id + "-\\d+");
          document.cookie = "products=" + expressionProduct[0].split('products=')[1].replace(regex, (item.id + '-' + (item.quantity - 1)));
          return { ...item, quantity: item.quantity - 1 }
        }
        else if (item.quantity > 1) {
          return { ...item, quantity: item.quantity - 1 }
        }
      }
      return item

    });

    setCart(updatedCart);
    handlePutToCart(updatedCart);
  };


  const getProduct = async (productId) => {
    try {
      setLoading(true);
      const response = await
        fetch(`${urls.BASE_URL}` + "/zedock-web/product/" + productId, {

          headers: {
            "X-XSRF-TOKEN": getCsrfToken()
          },
          method: "GET",
          credentials: "include"   // ✅ send JSESSIONID cookie
        });
      const data = await response.json();
      navigate("/Specifications", { state: data })
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container px-0    ">

      {loading ? (
        <div className="zd-loader-wrap text-center py-5">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="zd-wrap px-2 px-lg-4 py-3">

          <div className="row m-1">
            <nav aria-label="breadcrumb" className="zd-crumb">
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="" onClick={() => navigate("/Product")}>Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">Cart</li>
              </ol>
            </nav>

            <div className="col-12">
              <div className="d-flex align-items-baseline gap-2 mb-2">
                <h2 className="zd-cart-title mb-0">Your cart</h2>
                <span className="zd-cart-count">({cart.length} {cart.length === 1 ? "item" : "items"})</span>
              </div>


              {cart.map((item) => (
                <div key={item.id} className="zd-cart-item">

                  <div className="zd-cart-thumb">
                    <img src={urls.CDN_URL + 'products/' + item.sku + ".webp"} alt={item.name}
                      onClick={() => getProduct(item.productId)}
                    />
                  </div>

                  <div className="zd-cart-info">
                    <h6>{item.name}</h6>
                    <p className="zd-cart-desc">{item.description}</p>
                    <p className="zd-cart-delivery"><span className="dot"></span>Delivery in 3-5 days</p>
                  </div>

                  <div className="zd-cart-actions">
                    <div className="zd-qty-stepper">
                      <button type="button" className="zd-qty-btn" onClick={() => decreaseQuantity(item.id)}>−</button>
                      <span className="zd-qty-value">{item.quantity}</span>
                      <button type="button" className="zd-qty-btn" onClick={() => increaseQuantity(item.id)}>+</button>
                    </div>

                    <span className="zd-cart-price">{currency(item.price * item.quantity)}</span>

                    <button type="button" className="zd-remove-btn" onClick={() => removeFromCart(item.id)} aria-label="Remove item">
                      <svg viewBox="0 0 24 24" fill="none" stroke="#B4382E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="3 6 5 6 21 6"></polyline>
                        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
                        <path d="M10 11v6"></path>
                        <path d="M14 11v6"></path>
                        <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path>
                      </svg>
                    </button>
                  </div>

                </div>
              ))}
            </div>
          </div>

          <div className="row m-1">
            {cart.length === 0 && (
              <div className="col-12 col-lg-6 mx-auto">
                <div className="zd-empty">
                  <div className="zd-empty-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="9" cy="21" r="1"></circle>
                      <circle cx="20" cy="21" r="1"></circle>
                      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                    </svg>
                  </div>
                  <h2>Your cart is empty</h2>
                  <p>Add some products to get started!</p>
                  <button type="button" className="zd-cta" onClick={() => navigate("/Product")}>Start shopping</button>
                </div>
              </div>
            )}

            {cart.length > 0 && (
              <div className="col-12">
                <div className="zd-summary">
                  <div>
                    <span className="zd-summary-label">Order total</span>
                    <span className="zd-summary-total">{currency(total)}</span>
                  </div>
                  <button type="button" className="zd-checkout-btn" onClick={() => navigate("/Checkout", { state: { totalPrice: total } })}>Checkout</button>
                </div>
              </div>
            )}
          </div>

        </div>
      )}
    </div>
  );
}

export default Cart;
